/**
 * @extends com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestMessageHandler
 * @constructor
 *
 * This handler is to process Virtual agent messages, upon receiving virtual
 * agent message. This handler will process it by removing onclick event handler
 * and update the ide with the message timestamp.
 */
com.inq.flash.client.control.messagehandlers.CMSDKAutomatonRequestMessageHandler = function() {
	this.constructor.__super__.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_REQUEST);
};

$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,com.inq.flash.client.control.messagehandlers.CMSDKAutomatonRequestMessageHandler,"com.inq.flash.client.control.messagehandlers.CMSDKAutomatonRequestMessageHandler")

com.inq.flash.client.control.messagehandlers.CMSDKAutomatonRequestMessageHandler.prototype.processMessage = function(message) {

	/** @type {boolean} */
	var isReplay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) === "1";
	if (!isReplay) {
		com.inq.flash.client.control.Incrementality.onAgentMsg();
	}

	/** @type {string} */
	var vaDataPass = message.getProperty(com.inq.flash.client.data.MessageFields.TYPE_VA_DATA_PASS);
	if (vaDataPass) {
		com.inq.flash.client.control.Incrementality.onVADataPass(vaDataPass);
	}

	var autType = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_TYPE);
	if (autType != null) {
		if (autType == com.inq.flash.client.data.MessageFields.DATA_CHATROOM_MEMBER_VIRTUAL_AGENT) {
			var clientName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME);
			if (clientName != null) {
				com.inq.flash.client.control.FlashVars.setCustomerName(clientName, true);
			}
		}
	}

	var chatText = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA);
	chatText = this.handleCustomEventAttributes(chatText);

	var onclickRegex = /onclick(.*?)sendVALinkClicked\(event\).*?["']/;
	var vaLinkId = "automaton_vaLink_" + message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP)
	var vaLinkIdText = 'id="' + vaLinkId + '"';
	chatText = chatText.replace(onclickRegex, vaLinkIdText);

    if (com.inq.utils.Capabilities.isMobile()) {
        chatText = chatText.replace(/onclick/, "onTouchEnd");
    }

	message.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_AUTOMATON_DATA, chatText);
	this.controller.onNewChatRouterMessage(message);

};
